// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cb04203e","239":"b5025129","667":"f2a30500"}[chunkId] + ".chunk.js";
};